import BaseModel from "../core/BaseModel";
import constants from "../core/Constants";

var getContants = constants.getConstans();

export default class CarAccidentModel extends BaseModel {
  constructor() {
    super(
      {
        name: "car_accident",
        tableName: "car_accident",
        label: "Fixing Car",
      },
      {
        stt: {
          name: "stt",
          label: "No.",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },

        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },

        vehicle_category_name: {
          name: "vehicle_category_name",
          label: "Vehicle category",
          type: "Computed",
          class: "small-col-midle txt-left",
          width: 15,
          filter: { type: "input", match: "contains" },
          computed: (data) => {
            data.vehicle_category_name = "";
          },
        },
        license_plate_number: {
          name: "license_plate_number",
          label: "License plate number",
          type: "Computed",
          class: "small-col-midle txt-left",
          width: 15,
          filter: { type: "input", match: "contains" },
          computed: (data) => {
            data.license_plate_number = "";
          },
        },
        contact_name: {
          name: "contact_name",
          type: "String",
          label: "Renter name",
          class: "small-col-midle txt-left",
          width: 15,
          filter: { type: "input", match: "contains" },
          //display: false, // mock bảng trên chưa có Notes
        },
        contact_phone: {
          name: "contact_phone",
          type: "String",
          label: "Phone",
          class: "small-col-midle txt-left",
          width: 15,
          filter: { type: "input", match: "contains" },
          //display: false, // mock bảng trên chưa có Notes
        },

        accident_date_at: {
          name: "accident_date_at",
          type: "Date",
          width: 15,
          label: "Accident date",
          class: "center txt-small-col-midle txt-left",
          filter: { type: "DateRange", match: "contains" },
        },

        fixing_date_at: {
          name: "fixing_date_at",
          type: "Date",
          width: 15,
          label: "Fixing date",
          class: "center txt-small-col-midle txt-left",
          filter: { type: "DateRange", match: "contains" },
        },

        status_car: {
          name: "status_car",
          label: "Status",
          type: "Selection",
          custom: "SelectionText",
          options: getContants.CAR_FOR_RENT_STATUS,
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
          class: "small-col txt-left",
          computed: (data) => {
            data.status_car = "";
          },
        },
        fee: {
          name: "fee",
          type: "Number",
          label: "Expense",
          width: 10,
          class: "left",
        },

        // Nếu bạn cần show Notes ở bảng trên thì bật display + class tương tự reminder
        note: {
          name: "note",
          type: "String",
          label: "Notes",
          class: "large-col txt-left txt-ellipsis-3-line",
          width: 20,
          // filter: { type: "input", match: "contains" },
          //display: false, // mock bảng trên chưa có Notes
        },

        // Giữ refs để lấy data join từ rental_order_rent (đang dùng sẵn trong reminder)
        // Bạn bổ sung field accident_date / fixing_date vào refs nếu backend trả theo object này
        // detail_get: {
        //   refs:
        //     'rental_order_id vehicle_category_id car_for_rent_id renter_id contact_name contact_phone contact_email note accident_date fixing_date ' +
        //     'obj_rental_order_rent { vehicle_category_name vehicle_category_id license_plate_number car_for_rent_id contact_phone contact_name obj_rental_order { code booking_status } }',
        //   display: false,
        // },

        detail_get_2: {
          refs: "obj_vehicle_category{ name} obj_car_for_rent{ status license_plate_number} ",
          display: false,
        },
      }
    );
  }
}
